import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss']
})
export class ViewComponent implements OnInit {

  candidate_id:any
  candidate_data:any
  constructor(private apiService:ApiService,
    private activatedroute:ActivatedRoute,
    ) { 
    this.activatedroute.paramMap.subscribe(params => { 
    this.candidate_id = params.get('id');      
    });
  }

  ngOnInit(): void {
    this.getJobById()
  }
  getJobById(){
    this.apiService.getCandidatesById(this.candidate_id).subscribe((res:any)=>{
      if(res.statusCode == 200){
        this.candidate_data=res.data
      }
    })
  }

}
